// extracted by mini-css-extract-plugin
var _1 = "IcoRadio-module__legosRadio--YHLeA";
var _2 = "IcoRadio-module__pillRadio--nq_GF";
export { _1 as "legosRadio", _2 as "pillRadio" }
